import * as React from 'react';
import {
  numberCommaToDot,
  numberDotToComma,
  parseFloatCommaDot,
  numberToFixedString,
} from '../../Utils';
import {
  BootstrapTable,
  TableHeaderColumn,
  DeleteButton,
  ButtonGroup,
} from 'react-bootstrap-table';
import * as Modal from 'react-modal';
import {
  Component,
  Handler,
  getRandomKey,
  isNullOrEmpty,
  I18NString,
  clearNonNumberCharacters,
} from '../../Utils';
import { IControlError } from '../../Controls';
import { IDispatcher } from '../extensions/Dispatcher';
import Field from '../Field';
import GridMultipleFiles from './GridMultipleFiles';
import { isEmpty, isUndefined, findIndex, filter, indexOf } from 'lodash';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import { Button, Alert } from 'react-bootstrap';
import * as numeral from 'numeral';

interface TableColumExtraLookup {
  component?: string;
  column?: string;
}

interface TableExtraLogic {
  type?: string;
  override_columns?: any;
}

interface TableExtra {
  design?: Array<string>;
  logic?: TableExtraLogic;
  rename_row_title?: string;
}

interface TableColumExtra {
  lookup?: TableColumExtraLookup;
  logic?: TableExtraLogic;
  allow_rename?: boolean;
  renamed_required?: boolean;
  format?: string;
  file_formats?: Array<string>;
}

interface TableColum {
  field: string;
  name: string;
  description: I18NString;
  format?: any;
  editable?: any;
  hiddenOnInsert?: any;
  required: boolean;
  maxLength?: number;
  isKey: boolean;
  type?: any;
  options: any;
  extra?: TableColumExtra;
}

interface GridSchema extends IControlSchema {
  columns: Array<TableColum>;
  value?: Array<any>;
  disabled?: boolean;
  maxRowCount?: number;
  description?: I18NString;
  extra?: TableExtra;
}

interface IGridProps {
  schema: GridSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface IGridState {
  selectRow: object;
  values: Array<any>;
  showHelp: boolean;
}

export interface IControlSchema {
  id: string;
  type: string;
  contentNumb: string;
  disableNumber?: boolean;
  title: I18NString;
  required: boolean;
  viewableFor: Array<string>;
  visible?: boolean;
  rule?: {
    controlTergetId: string;
    option: number;
    value: string;
  };
}

interface ModalEditorState {
  open: boolean;
  mode: string;
}

interface ModalEditorProps {
  title: string;
  columns: Array<TableColum>;
  cells: Object;
  onSave: (row: object, mode: string) => void;
  dispatcher?: IDispatcher;
  rowCount: number;
  titleRow: Object;
}

interface EditorModalTableProps {
  columns: Array<TableColum>;
  onSave: (row: object, mode: string) => void;
  onModalClose: () => void;
  title: string;
  value?: Object;
  dispatcher?: IDispatcher;
  rowCount: number;
  titleRow: Object;
  mode: string;
}

interface EditorModalTableState {
  validateState: { [key: string]: string };
}

const prettyFileIcons = require('pretty-file-icons');
const importAll = (r) => {
  let modules = {};
  r.keys().map((item) => {
    modules[item.replace('./', '')] = r(item);
  });
  return modules;
};
const images = importAll(
  require['context']('pretty-file-icons/svg/', false, /\.(png|jpe?g|svg)$/),
);

class Description extends React.Component<
  { text: I18NString },
  { isOpen: boolean }
> {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <div>
        <div className="input-group">
          {this.props.children}
          {this.props.text && (
            <span
              onClick={this.onClick}
              className="input-group-addon btn btn-default  btn-circle"
            >
              <span className="glyphicon glyphicon-question-sign"></span>
            </span>
          )}
        </div>
        {this.props.text && this.state.isOpen && (
          <div className="alert alert-warning" role="alert">
            {this.props.text.ru}
          </div>
        )}
      </div>
    );
  }
}

class EditorModalTable extends React.Component<
  EditorModalTableProps,
  EditorModalTableState
> {
  public refs: { [key: string]: HTMLInputElement };

  state = {
    validateState: {},
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.checkIfNumber = this.checkIfNumber.bind(this);
    this.getColumnName = this.getColumnName.bind(this);
  }

  checkIfNumber(event) {
    const e = event;

    const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
    const charStr = String.fromCharCode(charCode);

    if (!charStr.match(/[0-9]+/)) {
      e.preventDefault();
    }
  }

  checkIfFloat(event) {
    const e = event;

    const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
    const charStr = String.fromCharCode(charCode);
    if (!charStr.match(/[0-9\.\,\-]+/)) {
      e.preventDefault();
    }
  }

  getFieldValue() {
    const newRow = {};

    this.props.columns.forEach((column: TableColum) => {
      newRow[column.field] = !this.isColumnSpecial(column)
        ? this.refs[column.field].value
        : column.isKey
        ? `key_${getRandomKey()}`
        : this.applyColumnLogic(this.props.columns, column);
    }, this);
    if (this.props.mode == 'title') {
      newRow['spec_col_names'] = true;
    }
    return newRow;
  }
  applyColumnLogic(columns: Array<TableColum>, column: TableColum) {
    //@ts-ignore
    if (column.extra && column.extra.logic == 'row_sum') {
      let num_res = 0;
      for (let col of columns) {
        if (!this.isColumnSpecial(col)) {
          let field = this.refs[col.field];
          if (field && field.value) {
            let n = parseFloatCommaDot(field.value);
            if (!isNaN(n)) {
              num_res += n;
            }
          }
        }
      }
      return numberToFixedString(num_res);
    }
    return '';
  }
  isColumnSpecial(column: TableColum) {
    if (column.isKey) return true;
    //@ts-ignore
    if (column.extra && column.extra.logic == 'row_sum') return true;
    return false;
  }

  onClick() {
    let rows = this.getFieldValue();
    let validateState = {};

    this.props.columns.forEach((column: TableColum) => {
      if (!this.isColumnSpecial(column)) {
        let value = this.refs[column.field].value;
        if (this.isColumnRequired(column) && value === '')
          validateState[column.field] = 'Обязательное поле для заполнения';
        if (
          value &&
          column.maxLength &&
          column.maxLength > 0 &&
          value.length > column.maxLength
        )
          validateState[column.field] =
            'Превышена допустимая длина поля. Допустимо: ' +
            column.maxLength +
            ', введено: ' +
            value.length;
        if (column.type == 'float') {
          if (value !== '') {
            let fval = parseFloatCommaDot(this.refs[column.field].value);
            if (isNaN(fval)) {
              validateState[column.field] = 'Введите число';
            } else {
              fval = Math.round(fval * 100.0) / 100.0;
              rows[column.field] = numberDotToComma(fval.toString());
            }
          }
        }
        if (column.type == 'file') {
          if (this.isColumnRequired(column)) {
            let files_value =
              typeof value === 'string' ? JSON.parse(value) : value;
            let file_found = false;
            for (let f of files_value) {
              if (f.value) {
                file_found = true;
                break;
              }
            }
            if (!file_found) {
              validateState[column.field] = 'Загрузите хотя бы один файл';
            }
          }
        }
      } else {
        if (column.isKey && !isUndefined(this.props.value))
          rows[column.field] = this.props.value[column.field];
      }
    }, this);

    this.setState({ validateState });
    if (isEmpty(validateState)) {
      this.props.onSave(rows, this.props.mode);
      this.props.onModalClose();
    }
  }

  createControl(column: TableColum) {
    const { value } = this.props;
    let defaultValue = '';
    if (column.name == '№') {
      return (
        <Description text={column.description}>
          <span ref={column.field}>
            {(value ? value[column.field] : this.props.rowCount + 1).toString()}
          </span>
        </Description>
      );
    }
    if (column.extra) {
      if (column.extra.lookup) {
        let lookup_columns = [];
        let lookup_components = [];

        if (Array.isArray(column.extra.lookup)) {
          for (let item of column.extra.lookup) {
            if (item.column && item.component) {
              lookup_columns.push(item.column);
              lookup_components.push(item.component);
            }
          }
        } else {
          lookup_columns.push(column.extra.lookup.column);
          lookup_components.push(column.extra.lookup.component);
        }

        let lookup_values_list = [];
        for (let i = 0; i < lookup_columns.length; i++) {
          let lookup_column = lookup_columns[i];
          let lookup_component = lookup_components[i];

          if (lookup_column && lookup_component) {
            let lookup_values = this.props.dispatcher.pullTableRows(
              lookup_component,
              lookup_column,
            );
            lookup_values_list = lookup_values_list.concat(lookup_values);
          }
        }
        return (
          <Description text={column.description}>
            <select
              ref={column.field}
              className="form-control"
              defaultValue={value && value[column.field]}
            >
              {lookup_values_list.map((str, idx) => {
                if (!str) return <option key={0} value={null}></option>;
                return (
                  <option key={str} value={str}>
                    {str}
                  </option>
                );
              })}
            </select>
          </Description>
        );
      }
    }
    if (column.type !== null) {
      switch (column.type) {
        case 'select':
          return (
            <Description text={column.description}>
              <select
                ref={column.field}
                className="form-control"
                defaultValue={value && value[column.field]}
              >
                {column.options &&
                  column.options.map((str, idx) => {
                    if (!str) return <option key={0} value={null}></option>;
                    return (
                      <option key={str.value} value={str.label['ru']}>
                        {str.label['ru'] || str}
                      </option>
                    );
                  })}
              </select>
            </Description>
          );
        case 'number':
          return (
            <Description text={column.description}>
              <input
                type="number"
                inputMode="decimal"
                className="form-control editor edit-text"
                onKeyPress={this.checkIfNumber}
                ref={column.field}
                defaultValue={
                  isUndefined(this.props.value)
                    ? defaultValue
                    : this.props.value[column.field]
                }
              />
            </Description>
          );
        case 'float':
          return (
            <Description text={column.description}>
              <input
                type="text"
                className="form-control editor edit-text"
                onKeyPress={this.checkIfFloat}
                ref={column.field}
                defaultValue={
                  isUndefined(this.props.value)
                    ? defaultValue
                    : this.props.value[column.field]
                }
              />
            </Description>
          );
        case 'file':
          return (
            <Description text={column.description}>
              <GridMultipleFiles
                field={column}
                defaultValue={
                  isUndefined(this.props.value)
                    ? null
                    : this.props.value[column.field]
                }
                dispatcher={this.props.dispatcher}
                onSave={this.props.onSave}
                ref={column.field}
                row={value}
                file_formats={
                  column.extra && column.extra.file_formats
                    ? column.extra.file_formats
                    : []
                }
              />
            </Description>
          );
        case 'TextArea':
          return (
            <Description text={column.description}>
              <textarea
                className="form-control editor edit-text"
                ref={column.field}
                defaultValue={
                  isUndefined(this.props.value)
                    ? defaultValue
                    : this.props.value[column.field]
                }
              />
            </Description>
          );
        default:
          return (
            <Description text={column.description}>
              <input
                type="text"
                className="form-control editor edit-text"
                ref={column.field}
                defaultValue={
                  isUndefined(this.props.value)
                    ? defaultValue
                    : this.props.value[column.field]
                }
              />
            </Description>
          );
      }
    } else {
      return (
        <Description text={column.description}>
          <input
            type="text"
            className="form-control editor edit-text"
            ref={column.field}
            defaultValue={
              isUndefined(this.props.value)
                ? defaultValue
                : this.props.value[column.field]
            }
          />
        </Description>
      );
    }
  }

  getColumnName(column: TableColum) {
    if (this.props.titleRow && this.props.titleRow[column.field]) {
      return this.props.titleRow[column.field];
    }
    return column.name;
  }
  isColumnRequired(column: TableColum): boolean {
    if (column.extra && column.extra.renamed_required) {
      if (this.props.titleRow && this.props.titleRow[column.field]) {
        return this.props.titleRow[column.field] != column.name;
      }
      return false;
    }
    return column.required;
  }
  render() {
    const { columns, onModalClose } = this.props;

    return (
      <div className="modal-content react-bs-table-insert-modal">
        <div className="modal-header ">
          <button type="button" className="close" onClick={onModalClose}>
            <span aria-hidden="true">×</span>
          </button>
          <h4 className="modal-title">{this.props.title}</h4>
        </div>
        <div className="modal-body">
          {columns.map((column: TableColum, idx: number) => {
            const { field, isKey, type } = column;
            let name = this.getColumnName(column);

            return (
              !this.isColumnSpecial(column) && (
                <div className="form-group" key={field}>
                  <label
                    className={this.isColumnRequired(column) ? 'required' : ''}
                  >
                    {name}
                  </label>
                  {this.createControl(column)}
                  {this.state.validateState[field] && (
                    <span className="label label-danger">
                      {this.state.validateState[field]}
                    </span>
                  )}
                </div>
              )
            );
          })}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default btn-secondary"
            onClick={onModalClose}
          >
            Отмена
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.onClick}
          >
            Сохранить
          </button>
        </div>
      </div>
    );
  }
}

class ModalEditor extends React.Component<ModalEditorProps, ModalEditorState> {
  state = {
    open: false,
    mode: 'rows',
  };

  onShow(mode: string) {
    this.setState({ open: true, mode: mode });
  }

  render() {
    let closeModal = () => this.setState({ open: false });
    let modal_value = this.props.cells;
    let modal_columns = this.props.columns;
    if (this.state.mode == 'title') {
      modal_columns = modal_columns.filter(
        (col) => (col.extra && col.extra.allow_rename) || col.isKey,
      );
      for (let col of modal_columns) {
        col.type = 'text';
      }
      modal_value = {};
      modal_value['spec_col_names'] = true;
      if (this.props.titleRow) {
        for (let col of modal_columns) {
          modal_value[col.field] = this.props.titleRow[col.field];
        }
      } else {
        for (let col of modal_columns) {
          if (col.isKey) {
            modal_value[col.field] = `key_${getRandomKey()}`;
          } else {
            modal_value[col.field] = col.name;
          }
        }
      }
    }

    return (
      // @ts-ignore
      <Modal
        isOpen={this.state.open}
        className="react-bs-insert-modal modal-dialog"
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <EditorModalTable
          title="Редактировать"
          value={modal_value}
          onModalClose={closeModal}
          columns={modal_columns}
          onSave={this.props.onSave}
          titleRow={this.props.titleRow}
          mode={this.state.mode}
          rowCount={this.props.rowCount}
          dispatcher={this.props.dispatcher}
        />
      </Modal>
    );
  }
}

class Grid extends Component<IGridProps, IGridState> {
  private modal: ModalEditor;

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDbClick = this.onDbClick.bind(this);
    this.helpClick = this.helpClick.bind(this);
    this.reassignRowNumbers = this.reassignRowNumbers.bind(this);
    this.getColumnName = this.getColumnName.bind(this);
    this.canRenameColumns = this.canRenameColumns.bind(this);
    this.getDataRows = this.getDataRows.bind(this);
    this.onColNames = this.onColNames.bind(this);

    this.state = {
      selectRow: {},
      values: [],
      showHelp: false,
    };
  }

  onClick() {
    if (!isEmpty(this.state.selectRow)) this.modal.onShow('rows');
  }

  onColNames() {
    this.modal.onShow('title');
  }

  getFieldKey() {
    const { columns } = this.props.schema;
    let idx = findIndex(columns, (col: TableColum) => col.isKey);

    return columns[idx].field;
  }

  applyTableLogic(values: Array<any>) {
    const { schema } = this.props;
    if (
      schema.extra &&
      schema.extra.logic &&
      schema.extra.logic.type == 'column_sum'
    ) {
      for (let v of values) {
        if (v.spec_summary) {
          /*
           * строка с "Итого" должна быть в конце массива
           * она всё равно вычислимая, удалим и
           * добавим в конец заново
           */
          let index = values.indexOf(v);
          if (index > -1) values.splice(index, 1);
          break;
        }
      }
      if (values.length == 0) {
        //множество пусто, строка "Итого" не требуется
        return;
      }
      let summary_row = null;
      summary_row = {};
      summary_row.spec_summary = true;
      for (let col of schema.columns) {
        if (col.isKey) {
          summary_row[col.field] = `key_${getRandomKey()}`;
        } else {
          summary_row[col.field] = 0;
        }
      }
      values.push(summary_row);
      for (let v of values) {
        if (v.spec_summary) continue;
        for (let col of schema.columns) {
          let cur_v = parseFloatCommaDot(v[col.field]);
          if (!isNaN(cur_v)) {
            summary_row[col.field] += cur_v;
          }
        }
      }
      for (let col of schema.columns) {
        if (
          schema.extra.logic.override_columns &&
          schema.extra.logic.override_columns[col.field]
        ) {
          summary_row[col.field] =
            schema.extra.logic.override_columns[col.field];
        } else {
          summary_row[col.field] = numberToFixedString(summary_row[col.field]);
        }
      }
    }
  }
  onSave(row: Object, mode: string) {
    if (typeof row === 'undefined') return;
    const { dispatcher, schema } = this.props,
      fieldKey = this.getFieldKey(),
      values = [...this.state.values],
      index = findIndex(
        values,
        (val: Object) => val[fieldKey] === row[fieldKey],
      );
    if (mode != 'title') {
      if (index > -1) values[index] = row;
      else values.push(row);
      this.applyTableLogic(values);
      this.reassignRowNumbers(values);
    } else {
      let titleRow = this.getTitleRow();
      if (titleRow) {
        let title_index = findIndex(
          values,
          (val: Object) => val[fieldKey] === row[fieldKey],
        );
        if (index > -1) {
          values[title_index] = row;
        } else {
          values.push(row);
        }
      } else {
        values.push(row);
      }
    }
    this.setState({ values: [...values] });
    if (
      this.state.selectRow &&
      this.state.selectRow[fieldKey] === row[fieldKey]
    ) {
      this.setState({ selectRow: row });
    }
    dispatcher.onBlur(schema.id, values, true, undefined);
  }

  onDelete() {
    const { schema, dispatcher } = this.props;
    // const values = [...this.state.values];

    if (!isEmpty(this.state.selectRow)) {
      let fieldKey = this.getFieldKey(),
        values = filter(
          typeof schema.value === 'string'
            ? JSON.parse(schema.value)
            : schema.value,
          (o: Object) => o[fieldKey] !== this.state.selectRow[fieldKey],
        );
      this.applyTableLogic(values);
      this.reassignRowNumbers(values);
      dispatcher.onBlur(schema.id, values, true, undefined);
      this.setState({ values: [...values], selectRow: {} });
    }
  }
  getColumnName(column: TableColum) {
    let titleRow = this.getTitleRow();
    if (titleRow && titleRow[column.field]) {
      return titleRow[column.field];
    }
    return column.name;
  }
  reassignRowNumbers(values) {
    const { schema } = this.props;
    let num_columns = Array<TableColum>();
    for (let c of schema.columns) {
      if (c.name == '№') {
        num_columns.push(c);
      }
    }
    if (num_columns.length == 0) return;
    for (let idx = 0; idx < values.length; idx++) {
      for (let nc of num_columns) {
        values[idx][nc.field] = (idx + 1).toString();
      }
    }
  }

  componentDidMount() {
    const {
      schema: { value },
      error,
    } = this.props;

    if (!isUndefined(value)) {
      var vals = typeof value === 'string' ? JSON.parse(value) : value;
      this.reassignRowNumbers(vals);
      this.setState({
        values: vals,
      });
    }
  }

  onDbClick(row) {
    this.setState({ selectRow: row });

    this.modal.onShow('rows');
  }

  helpClick() {
    this.setState({ showHelp: !this.state.showHelp });
  }
  canRenameColumns() {
    const { columns } = this.props.schema;
    for (let col of columns) {
      if (col.extra && col.extra.allow_rename) return true;
    }
    return false;
  }
  getDataRows() {
    return this.state.values.filter((row) => !row.spec_col_names);
  }
  getTitleRow() {
    let row = this.state.values.filter((row) => row.spec_col_names);
    return row.length > 0 ? row[0] : null;
  }
  render() {
    const {
      schema: { value, disabled, maxRowCount, visible, extra },
      error,
      dispatcher,
    } = this.props;
    const length = this.state.values ? this.getDataRows().length : 0;
    const errorMessage = error && error.message;

    const config = {
      insertRow: !disabled && (maxRowCount ? length < maxRowCount : true),
      deleteRow: !disabled,
      selectRow: {
        mode: 'radio',
        bgColor: '#ddd',
        hideSelectColumn: true,
        clickToSelect: true,
        onSelect: (row, isSelected: boolean, e) => {
          if (row.spec_summary) return false;
          this.setState({ selectRow: isSelected ? row : {} });
        },
      },
      options: {
        insertText: 'Добавить',
        noDataText: 'Нет данных для отображения',
        onRowDoubleClick: !disabled ? this.onDbClick : {},

        deleteBtn: (onClick: any) => (
          <Button onClick={this.onDelete} bsStyle="danger">
            <span className="fa fa-trash"></span>
            Удалить
          </Button>
        ),

        btnGroup: (props) => (
          <ButtonGroup>
            {props.insertBtn}
            {!disabled && (
              <Button bsStyle="success" onClick={this.onClick}>
                <span className="fa fa-edit"></span>
                {this.canRenameColumns()
                  ? 'Редактировать строку'
                  : 'Редактировать'}
              </Button>
            )}
            {props.editColsBtn}
            {this.canRenameColumns() && !disabled && (
              <Button bsStyle="success" onClick={this.onColNames}>
                <span className="fa fa-edit"></span>
                {this.props.schema.extra &&
                this.props.schema.extra.rename_row_title
                  ? this.props.schema.extra.rename_row_title
                  : 'Редактировать заголовок'}
              </Button>
            )}
            {props.deleteBtn}
            {!isUndefined(this.props.schema.description) && (
              <Button
                onClick={this.helpClick}
                bsStyle="primary"
                title="Справка"
                className="btn btn-default btn-add btn-circle"
              >
                <span className="glyphicon glyphicon-question-sign"></span>
              </Button>
            )}
          </ButtonGroup>
        ),

        insertModal: (onModalClose) => (
          <EditorModalTable
            title="Добавить"
            onModalClose={onModalClose}
            columns={this.props.schema.columns}
            titleRow={this.getTitleRow()}
            rowCount={length}
            onSave={this.onSave}
            mode={'rows'}
            dispatcher={dispatcher}
          />
        ),
      },
    };
    let customCell = function (cell, row) {
      let type = this.type;
      if (type == 'number' || type == 'float') {
        if (cell == '0') {
          return (
            <span className="number" title={cell}>
              -
            </span>
          );
        } else {
          if (this.extra && this.extra.format == 'currency') {
            if (cell && cell.length > 0) {
              return (
                <span className="number" title={cell}>
                  {numeral(parseFloatCommaDot(cell)).format('0,0[.]00')}
                </span>
              );
            } else {
              return <span className="number" title={cell}></span>;
            }
          } else {
            return (
              <span className="number" title={cell}>
                {cell}
              </span>
            );
          }
        }
      }
      return <span title={cell}>{cell}</span>;
    };
    let fileCell = (cell, row) => {
      const parseCell = cell && JSON.parse(cell);
      const title =
        parseCell &&
        parseCell.map((cell) => {
          if (!cell || !cell.value) return;
          const extension =
            (cell.value.toLowerCase().endsWith('.docx') && ' .doc') ||
            (!cell.value.toLowerCase().endsWith('.docx') && cell.value);
          const fileIconPath = prettyFileIcons.getIcon(extension);
          const fileIcon = images[fileIconPath + '.svg'];
          const html = `<a class="file-grid" href="${cell.url}" download title="${cell.value}"><img class="fileicon fileicon--ingrid" src=${fileIcon.default} alt=${cell.value} /> ${cell.value}</a>`;
          return html;
        });
      return (
        <span
          title={cell}
          dangerouslySetInnerHTML={{ __html: title && title.join('<br />') }}
        />
      );
    };
    let getTdStyle = function (column) {
      if (column.type == 'number' || column.type == 'float') {
        return {
          whiteSpace: 'normal',
          textAlign: 'right',
        };
      }
      return {
        whiteSpace: 'normal',
      };
    };
    return isUndefined(visible) || visible ? (
      <Field
        {...this.props.schema}
        status={isEmpty(this.getDataRows()) ? 'default' : 'success'}
        fullwidth={extra && extra.design.indexOf('fullwidth') > -1}
      >
        <BootstrapTable
          {...config}
          data={this.getDataRows()}
          bodyContainerClass="react-bs-container-body_v1"
        >
          {this.props.schema.columns.map((column: TableColum, idx: number) => {
            if (column.type === 'file') {
              return (
                <TableHeaderColumn
                  isKey={column.isKey}
                  hidden={column.isKey}
                  thStyle={{ whiteSpace: 'normal' }}
                  tdStyle={getTdStyle(column)}
                  dataFormat={fileCell.bind(column)}
                  key={idx}
                  dataField={column.field}
                >
                  {this.getColumnName(column)}
                </TableHeaderColumn>
              );
            }
            return (
              <TableHeaderColumn
                isKey={column.isKey}
                hidden={column.isKey}
                thStyle={{ whiteSpace: 'normal' }}
                tdStyle={getTdStyle(column)}
                dataFormat={customCell.bind(column)}
                key={idx}
                dataField={column.field}
              >
                {this.getColumnName(column)}
              </TableHeaderColumn>
            );
          })}
        </BootstrapTable>
        <ModalEditor
          ref={(modal) => (this.modal = modal)}
          title="Редактировать"
          columns={this.props.schema.columns}
          rowCount={length}
          onSave={this.onSave}
          titleRow={this.getTitleRow()}
          cells={this.state.selectRow}
          dispatcher={dispatcher}
        />
        {errorMessage && <Alert bsStyle="danger">{errorMessage}</Alert>}
        {this.state.showHelp && (
          <Alert bsStyle="warning">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.schema.description.ru,
              }}
            ></div>{' '}
          </Alert>
        )}
      </Field>
    ) : (
      <div></div>
    );
  }
}

export function createGrid(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <Grid
      schema={schema as GridSchema}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  );
}
